import { useEffect, useRef } from 'react';
import type { AnyObject } from '../../../../../types';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';
import { useIsForegroundNow } from '../../../../../hooks';
import type { RollingBannerItem } from '../types';

/**
 * 현재 보이는 배너의 VIEW_BANNER 디스플레이 로깅.
 * - currentIndex가 바뀔 때마다 한 번씩만 발화 (sentIndices 기록)
 * - entity가 바뀌면 sentIndices 초기화 (iOS DisplayTracker.refresh 와 동일)
 * - foreground 아닐 때는 발화하지 않음
 */
export const useLogDisplayBanner = ({
  entity,
  logging,
  currentIndex,
}: {
  entity: RollingBannerItem[];
  logging: AnyObject;
  currentIndex: number;
}) => {
  const isForegroundNow = useIsForegroundNow();
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const displayedIndicesRef = useRef<Set<number>>(new Set());

  useEffect(() => {
    displayedIndicesRef.current = new Set();
  }, [entity]);

  useEffect(() => {
    if (entity.length === 0) return;
    if (!isForegroundNow) return;

    const bannerItem = entity[currentIndex];
    if (!bannerItem) return;

    if (displayedIndicesRef.current.has(currentIndex)) return;
    displayedIndicesRef.current.add(currentIndex);

    logAnalyticsEvent({
      name: 'VIEW_BANNER',
      analytics: {
        ...logging.analytics,
        ...bannerItem.logging.analytics,
      },
      ably_only_log: {
        ...(logging.ably_only_log as AnyObject),
        ...(bannerItem.logging.ably_only_log as AnyObject),
      },
    });
  }, [currentIndex, isForegroundNow, entity, logging, logAnalyticsEvent]);
};
